export const GENDER_CHOICES = {
    f: {
        en: 'Female',
        es: 'Femenino'
    },
    m: {
        en: 'Male',
        es: 'Masculino'
    },
    n: {
        en: 'Non-binary',
        es: 'No binario'
    },
    dna: {
        en: 'Prefer not to answer',
        es: 'Prefiero no responder'
    }
} as Record<string, { en: string; es: string }>;
